import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import DashboardLayout from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";
import {
  AdminFoundersKeys,
  sendAdminFounderStripeReminder,
} from "@/features/founders/api/admin-founders";
import FoundersTable from "@/features/founders/components/FoundersTable";
import NewFounderDrawer from "@/features/founders/components/NewFounderDrawer";
import { useToast } from "@/hooks/use-toast";

const Founders = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [selectedFounderId, setSelectedFounderId] = React.useState<
    string | null
  >(null);

  const onSetViewEditFounder = (id: string) => {
    setSelectedFounderId(id);
    setOpenDrawer(true);
  };

  const onClearFounderSelection = () => {
    setSelectedFounderId(null);
    setOpenDrawer(false);
  };

  // Handle Stripe reminder from table
  const { mutate: handleStripeReminder } = useMutation({
    mutationFn: sendAdminFounderStripeReminder,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [AdminFoundersKeys.GET_FOUNDERS],
      });
      toast({ title: "Stripe reminder sent successfully!" });
    },
    onError: () => {
      toast({
        title: "Failed to send stripe reminder",
        variant: "destructive",
      });
    },
  });

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Typography size="h1">Founders</Typography>
          <Button onClick={() => setOpenDrawer(true)} disabled>New Founder</Button>
        </div>

        <FoundersTable
          setFounderId={onSetViewEditFounder}
          onSendStripeReminder={handleStripeReminder}
        />

        <NewFounderDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          selectedFounderId={selectedFounderId}
          onClearFounderSelection={onClearFounderSelection}
        />
      </div>
    </DashboardLayout>
  );
};

export default Founders;
